import React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

//Custom Components
import TableButton from "./TableButton";

//Types
import { ITableActionButtonDetail } from "@/@types/ui/Table";


function TableButtonToggleOdrzan(props: ITableActionButtonDetail) {
  const { t } = useTranslation();

  return (
    <TableButton endIcon={<EventAvailableIcon/>} allow="one" selection={[]} {...props}>
     {t('buttons.is_odrzan')}
    </TableButton>
  );
}

export default TableButtonToggleOdrzan;
